enum EnumSituacaoAcaoObrigacao {
	Nenhum = 0,
	NoPrazo = 1,
	ConcluidaNoPrazo = 2,
	Atrasada = 3,
	ConcluidaComAtraso = 4,
}

export default EnumSituacaoAcaoObrigacao;
